module.exports = __webpack_public_path__ + "media/subway/L-aa7b5a3c.png";